import type { Drag, Phase, StageRecord } from "./types";
import { MONSTERS } from "./monsters";

/** Mutable, session-global game state. Kept in one object so feature modules
 *  can share it without a tangle of cross-module setters. */
export const state = {
  phase: "intro" as Phase,
  monsterIndex: 0,
  /** Current stage's inventory dimensions (grow from stage to stage). */
  cols: MONSTERS[0].grid.cols,
  rows: MONSTERS[0].grid.rows,
  /** Current grid cell size in px (recomputed responsively on resize). */
  cellPx: 48,
  /** The in-progress pointer drag, or null. */
  drag: null as Drag | null,
  /** Monotonic id source for loot pieces. */
  nextId: 1,
  /** Frozen record of how each completed stage was packed (for the reveal). */
  stages: [] as StageRecord[],
};
